<template>
    <div class="loader-wrap" :style="{position: position}">
        <div>
            <div class="loader"></div>
            <p class="u-mb0">
                <slot></slot>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseLoader",
        props: {
          position: {
            type: String,
            default: 'fixed'
          }
        }
    }
</script>
